enum ActionTypes {
  SET_WIDGETS = 'app/HomePage/SET_WIDGETS',

  HOME_PRODUCTS_REQUEST = 'app/HomePage/HOME_PRODUCTS_REQUEST',
  HOME_PRODUCTS_SUCCESS = 'app/HomePage/HOME_PRODUCTS_SUCCESS',
  HOME_PRODUCTS_FAILURE = 'app/HomePage/HOME_PRODUCTS_FAILURE',

  HOME_FAVORITE = 'app/HomePage/HOME_FAVORITE',
  HOME_FAVORITE_REQUEST = 'app/HomePage/HOME_FAVORITE_REQUEST',
  HOME_FAVORITE_SUCCESS = 'app/HomePage/HOME_FAVORITE_SUCCESS',
  HOME_FAVORITE_FAILURE = 'app/HomePage/HOME_FAVORITE_FAILURE',

  HOME_SET_PRODUCT_NOTE = 'app/MainLayout/HOME_SET_PRODUCT_NOTE',
  HOME_SET_PRODUCT_NOTE_REQUEST = 'app/MainLayout/HOME_SET_PRODUCT_NOTE_REQUEST',
  HOME_SET_PRODUCT_NOTE_SUCCESS = 'app/MainLayout/HOME_SET_PRODUCT_NOTE_SUCCESS',
  HOME_SET_PRODUCT_NOTE_FAILURE = 'app/MainLayout/HOME_SET_PRODUCT_NOTE_FAILURE',
  HANDLE_ADD_ALL_TO_FAVORITE = 'app/HomePage/HANDLE_ADD_ALL_TO_FAVORITE',

  LOAD_MORE_SECTION = 'app/HomePage/LOAD_MORE_SECTION',
}

export default ActionTypes;
